module.exports = __webpack_public_path__ + "static/media/stop_timer.c5f0b86c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gJunior/stop_timer.svg
// module id = 332
// module chunks = 21